import { useContext } from 'react'
import { FeatureFlagsContext } from '../contexts/FeatureFlagsContext'
import type { FeatureFlagsContextValue } from '../contexts/FeatureFlagsContext'

export const useFeatureFlags = (): FeatureFlagsContextValue => {
  const context = useContext(FeatureFlagsContext)
  if (context === undefined) {
    throw new Error('useFeatureFlags must be used within a FeatureFlagsProvider')
  }
  return context
}
